import * as ng from 'angular';
import { UiRights } from '../../../../../configuration';
import { AuthContextService } from '../../../../../services';
import { OrganismOverviewController, OverviewDataObject } from '../../../../organisms';

export class MoleculeOverviewRowPanelEmailController implements ng.IController {
    public static $inject: string[] = ['$state'];

    public userHasRightBilBundleList = AuthContextService.isGranted(UiRights.BIL_BUNDLE_LIST); // used in template!
    public overviewData: OverviewDataObject;
    public overviewLoad: (selection: any) => any;
    public internalPaginationLimit: number;
    public OrganismOverview: OrganismOverviewController;
    public sideEntryPoint: string;
    public stateGlobals: any;

    constructor(
        public $state: ng.ui.IStateService
    ) {}

    public $onInit() {
        this.sideEntryPoint = this.$state.current.name.split('.')[0];
        this.stateGlobals = this.$state.$current.locals.globals;
    }

    public get showAccounts() {
        return this.OrganismOverview.globals.showAccounts;
    }
}

export class MoleculeOverviewRowPanelEmailComponent implements ng.IComponentOptions {
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public bindings = {
        internalPaginationLimit: '<',
        overviewData: '<',
        overviewLoad: '<'
    };
    public controller =  MoleculeOverviewRowPanelEmailController;
    public controllerAs = 'OverviewEmailCtrl';
    public template = require('./email-row.html');
}
